import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resume")({
  component: Resume,
});

// Ported from design-reference/resume-disassembler.html. Reuses the site
// Rail/theme chrome instead of the prototype's standalone mini-rail — the
// content (sections, entries, skills, awards) is what's load-bearing here.
function Resume() {
  return (
    <>
      <p className="frame-label">
        frame <b>#0</b> — resume.dump
      </p>
      <h1>Rounak Kumar Singh</h1>
      <p className="role">
        B.Tech student — Object-Oriented Design, Algorithms &amp; Data Structures, Systems
        Programming
      </p>

      <div className="contact-line">
        {/* <span>+91 7978049275</span> */}
        <a href="mailto:hello@rounakkumarsingh.com">hello@rounakkumarsingh.com</a>
      </div>

      <div className="sec-head" style={{ marginTop: "2rem" }}>
        <span className="addr">0x0001</span>
        <h2>summary()</h2>
      </div>
      <div className="listing">
        <div className="line">
          <span className="addr">ret</span>
          <span>
            Detail-oriented B.Tech student at IIEST Shibpur, skilled in Object-Oriented Design,
            complexity analysis, algorithms, and data structures. Hands-on experience through
            academic projects and an internship — including a pipeline redesign that improved output
            size by up to 60%.
          </span>
        </div>
      </div>

      <div className="sec-head">
        <span className="addr">0x0010</span>
        <h2>experience[]</h2>
      </div>
      <div className="entry">
        <div className="entry-head">
          <span>Accenture — Software Engineering Intern</span>
          <span className="when">May 2026 – Jul 2026</span>
        </div>
        <div className="listing">
          <div className="line active">
            <span className="addr">call</span>
            <span>
              Redesigned a single-step LLM generation pipeline into a 3-stage multi-agent workflow
              (analysis, generation, validation), orchestrated with LangGraph, on an internal
              automation platform.
            </span>
          </div>
          <div className="line">
            <span className="addr">call</span>
            <span>
              Decomposed a monolithic generation step into staged, independently verifiable tasks
              using Object-Oriented Design principles — significant reduction in output complexity
              while preserving correctness.
            </span>
          </div>
          <div className="line">
            <span className="addr">call</span>
            <span>
              Deployed pipeline stages as asynchronous Celery workers backed by RabbitMQ and Redis,
              enabling fault-isolated, independently scalable task execution.
            </span>
          </div>
          <div className="line">
            <span className="addr">ret</span>
            <span>Reduced output size by up to 60% on very large outputs.</span>
          </div>
        </div>
        <div className="tags">
          <span className="tag">LangGraph</span>
          <span className="tag">Celery</span>
          <span className="tag">RabbitMQ</span>
          <span className="tag">Redis</span>
          <span className="tag">OOD</span>
        </div>
      </div>

      <div className="sec-head">
        <span className="addr">0x0020</span>
        <h2>projects[]</h2>
      </div>
      <div className="entry">
        <div className="entry-head">
          <span>RAG Search Engine</span>
          <span className="when">
            <a className="inline-ext" href="https://github.com/rounakkumarsingh" target="_blank" rel="noopener noreferrer">
              GitHub ↗<span className="ext-note"> (opens in a new tab)</span>
            </a>
          </span>
        </div>
        <div className="listing">
          <div className="line">
            <span className="addr">call</span>
            <span>
              Built a hybrid retrieval pipeline over 5,000 movies — hand-implemented BM25 inverted
              index (Porter stemming, tunable k1/b) fused with all-MiniLM-L6-v2 dense embeddings via
              weighted (α) and RRF (k=60) fusion at 5× candidate over-fetch.
            </span>
          </div>
          <div className="line">
            <span className="addr">call</span>
            <span>
              Implemented three rerankers — per-item LLM scoring, batch LLM JSON ranking, and a
              local ms-marco-TinyBERT-L2-v2 cross-encoder — with automatic RRF-order fallback on LLM
              failures.
            </span>
          </div>
          <div className="line">
            <span className="addr">ret</span>
            <span>
              Wrote a golden-dataset evaluation harness scoring Precision@k, Recall@k, and F1 across
              10 hand-labeled queries.
            </span>
          </div>
        </div>
        <div className="tags">
          <span className="tag">Python 3</span>
          <span className="tag">sentence-transformers</span>
          <span className="tag">FAISS</span>
          <span className="tag">OpenRouter</span>
        </div>
      </div>
      <div className="entry">
        <div className="entry-head">
          <span>DNS Server</span>
          <span className="when">
            <a className="inline-ext" href="https://github.com/rounakkumarsingh" target="_blank" rel="noopener noreferrer">
              GitHub ↗<span className="ext-note"> (opens in a new tab)</span>
            </a>
          </span>
        </div>
        <div className="listing">
          <div className="line">
            <span className="addr">call</span>
            <span>
              Built a fully compliant recursive DNS resolver in Go following RFC 1034/1035 —
              goroutine-per-request UDP handling with TCP fallback for truncated responses.
            </span>
          </div>
          <div className="line">
            <span className="addr">call</span>
            <span>
              Parsed and constructed raw DNS packets with label compression and multi-section
              support across A, AAAA, NS, MX, CNAME, TXT, SOA, and OPT record types.
            </span>
          </div>
          <div className="line">
            <span className="addr">ret</span>
            <span>
              Resolved queries iteratively from root nameservers, following NS referrals and CNAME
              chains, with TTL-aware caching and periodic cleanup.
            </span>
          </div>
        </div>
        <div className="tags">
          <span className="tag">Go</span>
          <span className="tag">DNS</span>
          <span className="tag">Networking</span>
        </div>
      </div>

      <div className="sec-head">
        <span className="addr">0x0030</span>
        <h2>skills{"{}"}</h2>
      </div>
      <div className="skill-row">
        <span className="k">languages</span>
        <span className="v">Python, Java, JavaScript, TypeScript, Go, C, C++</span>
      </div>
      <div className="skill-row">
        <span className="k">frameworks</span>
        <span className="v">
          React, ExpressJS, FastAPI, Hono, LangChain, Prometheus, Grafana, Loki
        </span>
      </div>
      <div className="skill-row">
        <span className="k">databases</span>
        <span className="v">PostgreSQL, MongoDB, Drizzle ORM, Mongoose</span>
      </div>
      <div className="skill-row">
        <span className="k">tools</span>
        <span className="v">
          Git, GitHub, Docker, Kubernetes, AWS, GCP, Cloudflare Workers, NGINX, Unix Shell
        </span>
      </div>

      <div className="sec-head" style={{ marginTop: "2rem" }}>
        <span className="addr">0x0040</span>
        <h2>education()</h2>
      </div>
      <div className="entry">
        <div className="entry-head">
          <span>Indian Institute of Engineering Science and Technology, Shibpur</span>
          <span className="when">Aug 2023 – Aug 2027</span>
        </div>
        <div className="entry-sub">B.Tech. — CGPA 8.55/10.0</div>
        <div className="listing">
          <div className="line">
            <span className="addr">note</span>
            <span>
              Object-Oriented System Design, Complexity Analysis, Data Structures, Algorithms,
              Discrete Mathematics, Linear Algebra, Probability &amp; Statistics, Computer
              Organization &amp; Architecture, Formal Languages &amp; Automata Theory, Operating
              Systems, DBMS.
            </span>
          </div>
        </div>
      </div>

      <div className="sec-head">
        <span className="addr">0x0050</span>
        <h2>awards[]</h2>
      </div>
      <div className="listing">
        <div className="line">
          <span className="addr">-</span>
          <span>
            Highest global rank <b>270</b> in a CodeChef contest — 3-Star rated (1653).
          </span>
        </div>
        <div className="line">
          <span className="addr">-</span>
          <span>
            Solved <b>750+</b> Data Structures &amp; Algorithms problems across platforms.
          </span>
        </div>
        <div className="line">
          <span className="addr">-</span>
          <span>
            Contributed to open source during GirlScript Summer of Code 2024 and Hacktoberfest 2024.
          </span>
        </div>
      </div>
    </>
  );
}
